import type { State } from '../../typings'

export function clearAllFiltersReducer(state: State): State {
  const newState: State = { ...state }

  newState.filters.closingActivities.filters.forEach((x) => {
    x.isSelected = false
  })

  newState.filters.customActivities.filters.forEach((x) => {
    x.isSelected = false
  })

  newState.filters.statusUpdates.filters.forEach((x) => {
    x.isSelected = false
  })

  return newState
}
